<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-15 11:08:53
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 11:21:06
 * @FilePath: /h5/Users/xiaoyouzi/Documents/work/移动端/m-ai.nongji360.com/src/views/Login/CodeLogin.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="input-box">
			<van-field class="input-item" v-model="loginForm.username" clearable maxlength="11" :left-icon="require('@/assets/images/spark/phone_icon.png')" placeholder="请输入手机号码" />
			<van-field class="input-item" v-model="loginForm.verifyCode" clearable maxlength="18" :left-icon="require('@/assets/images/spark/code_icon.png')" placeholder="请输入验证码">
				<van-button class="btn-code" slot="button" size="small" @click="getCode()">{{getcodetxt}}</van-button> 
			</van-field>
		<div class="btn-submit" @click="submit()">登录</div>
		<!-- <div class="btn-register">立即注册</div> -->
		<van-popup round v-model="verifyPopShow">
			<slider-verify
				ref="sliderVerify"
				:appid="appid"
				:appsecret="appsecret"
				:block-height="50"
				:block-width="50"
				:disabled="disabled"
				:host="host"
				:slide-bg="slideBg"
				:slide-btn-bg="slideBtnBg"
				:canvas-width="canvasWidth"
				:canvas-height="200"
				style="width: 100%"
				@again="onAgain"
				@fail="onFail"
				@success="onSuccess"
			/>
		</van-popup>
		
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loginForm: {
          username: '', //手机号
          verifyCode: '', //验证码
					sysFlag:-1,
        },
				getcodetxt: '获取验证码',
    		getcode_disabled:false,

				verifyPopShow:false,//验证码弹框显示
				host: "https://bs.datian360.com",//正式
        appid: "njwst",
        appsecret: "njwst",
        slideBtnBg: "#71B019",
        slideBg: "#71B019",
        disabled: false,
        canvasWidth: 370,

			}
		},
		mounted() {
			
  	},
  	methods: {
			 /**
     * @Description: 滑动成功
     * @Author: sunruyan
     * @Date: 2024-03-25 10:13:02
     * @param {*} captcha
     * @return {*}
     */
     onSuccess(captcha) {
      const { nonceStr, value } = captcha;
      this.$refs.sliderVerify.verifySuccessEvent();
      // if (this.loginForm.username && this.loginForm.verifyCode) {
        // this.getCode({ nonceStr, value });
				// this.timer(60);
				this.$http.login.getSmsCode({mobile:this.loginForm.username, type:4,codeType:"slide",nonceStr,value}).then(res => {
					this.$toast("验证码发送成功");
					this.verifyPopShow = false;
					this.getcodetxt = "60s";
					this.getcode_disabled = true;
					this.timer(60);
				})
        this.$refs.sliderVerify.refresh().catch((_) => {});
      // } else {
      //   this.$message.error("请先输入用户名，密码！");
      //   this.$refs.sliderVerify.refresh().catch((_) => {});
      // }
    },
    /**
     * @Description: 滑动失败
     * @Author: sunruyan
     * @Date: 2024-03-25 10:13:22
     * @return {*}
     */
    onFail() {
      this.$refs.sliderVerify.verifyFailEvent();
    },
    /**
     * @Description: 滑动异常
     * @Author: likk
     * @Date: 2024-03-25 10:13:33
     * @return {*}
     */
    onAgain() {
      this.$message.error("滑动验证失败，请重试");
      this.$refs.sliderVerify.refresh().catch((_) => {});
    },
			// 获取验证码
			getCode(params,){
    		const mobile = this.loginForm.username, reg = /^1[3456789]\d{9}$/;
    		if (this.getcode_disabled) return;
				if (mobile==''){
					this.$toast("请输入手机号");
					return false;
				}
				if (!reg.test(mobile)){
					this.$toast("手机号格式错误");
					return false;
				}
				this.verifyPopShow = true;
				this.$nextTick(() => {
					this.canvasWidth = this.$refs.sliderVerify.$el.offsetWidth;
					//初始化滑块验证码插件
					this.$refs.sliderVerify.init();
				});
				
			},
      /**
       * @description: 倒计时
       * @return {*}
       */			
			timer(steep){
				if (typeof (steep) == 'undefined') steep = 60;
				let setTimeout_o = setTimeout( () => {
					steep--;
					if (steep == 0) {
						this.getcodetxt = "重新获取";
						this.getcode_disabled = false;
					} else {
						this.getcodetxt =`${steep}S`;
						this.timer(steep);
					}
				}, 1000);
			},
      async submit() {
        const { verifyCode,username } = this.loginForm, reg = /^1[3456789]\d{9}$/;
				if (username==''){
					this.$toast("请输入手机号");
					return false;
				}
				if (!reg.test(username)){
					this.$toast("手机号格式错误");
					return false;
				}
				if (!verifyCode) {
          this.$toast("请输入验证码");
          return;
        }
				this.$emit("submit",this.loginForm);
				// this.$store.dispatch("Login",this.loginForm).then(res => {
				// 	this.$store.dispatch("GetUserInfo");
				// 	this.$toast("登录成功");
				// 	// this.$router.push("/")
				// })
				// const {access_token} = await this.$http.login.login(this.loginForm);
				// if(access_token){
				// 	this.$store.commit('setAccessToken', access_token);
					
				// }
      },
    }
	}
</script>

<style lang="scss" scoped>
	.input-box{
		width: 100%;
		margin-top: 20px;
		.input-item{
			width: 100%;
			height: 54px;
			border-radius: 9px;
			background: #ffffff;
			box-shadow: 0px 0px 18px rgba(0,0,0,0.08);
			display: flex;
			align-items: center;
			margin-bottom: 15px;
			font-size: 17px;
			// .icon-img{
			// 	width: 18px;
			// 	height: auto;
			// 	margin-left: 12px;
			// }
			.btn-code{
				width: 86px;
				height: 30px;
				background: linear-gradient(90deg, #8FDE21 0%, #639B14 100%);
				box-shadow: 0px 0px 9px rgba(0,0,0,0.08);
				border-radius: 6px;
				color: #ffffff;
			}
		}
		.btn-submit{
			width: 100%;
			height: 54px;
			background: linear-gradient(90deg, #8FDE21 0%, #639B14 100%);
			box-shadow: 0px 0px 9px rgba(0,0,0,0.08);
			border-radius: 9px;
			font-size: 18px;
			color: #FFFFFF;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.btn-register{
			padding: 20px 0;
			font-size: 16px;
			color: #888888;
			text-align: center;
		}
		
	}
	.van-popup{
		width: 80%;
		padding: 15px;
	}
</style>